export const FooterLinks = {
    FANCENTRAL: 'https://fancentral.muzado.com',
    ABOUT: 'https://fancentral.muzado.com/about',
    HOWITWORKS: 'https://fancentral.muzado.com/how_it_works',
    PRESS: 'https://fancentral.muzado.com/press',

    ARTISTCENTRAL: 'https://artistcentral.muzado.com',
    LABELS: 'https://artistcentral.muzado.com/labels',

    //TODO: Fill in Terms and Privacy Policy with actual links
    TERMS: '',
    PRIVACY: '',
    CONTACTUS: 'mailto:contact@muzado.com?&subject=MZD%20Web%20Inquiry',

    FACEBOOK: 'https://facebook.com/muzadomusic',
    TWITTER: 'https://twitter.com/muzadomusic',
    INSTAGRAM: 'https://instagram.com/muzadomusic',
    YOUTUBE: 'https://youtube.com/muzadomusic',
}